import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    transition: transform 0.3s;\n  }\n  :hover {\n    svg {\n      transform: scale(1.2);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 24px;\n  margin-right: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Text from "../Text/Text";
import Skeleton from "../Skeleton/Skeleton";
import Coin from "../../../../../public/logo.png";
var PriceLink = styled.a.withConfig({
    componentId: "sc-494b541a-0"
})(_templateObject());
var CoinLogo = styled.img.withConfig({
    componentId: "sc-494b541a-1"
})(_templateObject1());
var CakePrice = function(param) {
    var cakePriceUsd = param.cakePriceUsd, _color = param.color, color = _color === void 0 ? "textSubtle" : _color, _showSkeleton = param.showSkeleton, showSkeleton = _showSkeleton === void 0 ? true : _showSkeleton;
    return cakePriceUsd ? /*#__PURE__*/ _jsxs(PriceLink, {
        href: "/swap",
        children: [
            /*#__PURE__*/ _jsx(CoinLogo, {
                src: Coin.src
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: "chart-text",
                color: color,
                bold: true,
                children: "".concat(cakePriceUsd.toFixed(2).replace(".", ","), " €")
            })
        ]
    }) : showSkeleton ? /*#__PURE__*/ _jsx(Skeleton, {
        width: 80,
        height: 24
    }) : null;
};
export default /*#__PURE__*/ React.memo(CakePrice);
